/* Mobile quick-options disclosure. Existing filter controllers retain all filtering. */
(() => {
  if (window.efMobileQuickOptions) return;
  window.efMobileQuickOptions = true;
  let sequence = 0;
  function init(root, bbq = false) {
    if (root.dataset.efQuickReady) return;
    const bar = root.querySelector(bbq ? '.ef-bbq-filters__bar' : '.efxc-bar__inner');
    if (!bar || (!bbq && !bar.querySelector('[data-efxc-open-drawer]'))) return;
    const query = bbq ? '[data-bbq-quick]' : '[data-efxc-swap="chips"]';
    const id = 'ef-mobile-quick-' + (++sequence);
    const button = document.createElement('button');
    button.type = 'button'; button.className = 'ef-mobile-quick';
    button.setAttribute('aria-controls', id);
    button.innerHTML = '<span class="ef-mobile-quick__count"></span><span class="ef-mobile-quick__symbol" aria-hidden="true">+</span>';
    bar.append(button);
    let open = false;
    function update() {
      const panel = root.querySelector(query);
      if (!panel) return;
      panel.id = id;
      const available = !!panel.querySelector('a,button,input,select');
      const selected = [...panel.querySelectorAll('[aria-current="true"],[aria-pressed="true"],input:checked')]
        .filter(el => !el.matches('[data-efxc-clear],[data-efxc-browse-all]') && el.textContent.trim().toLowerCase() !== 'all');
      const labels = [...new Set(selected.map(el => el.textContent.trim()).filter(Boolean))];
      const count = labels.length;
      const label = (open ? 'Hide quick options' : 'Show quick options') + (count ? ', ' + count + ' selected: ' + labels.join(', ') : '');
      if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
      button.title = label;
      button.setAttribute('aria-expanded', String(open));
      const symbol = button.querySelector('.ef-mobile-quick__symbol');
      if (symbol.textContent !== (open ? '−' : '+')) symbol.textContent = open ? '−' : '+';
      button.hidden = !available;
      const counter = button.querySelector('.ef-mobile-quick__count');
      const value = count ? String(count) : '';
      if (counter.textContent !== value) counter.textContent = value;
      root.dataset.efQuickOpen = String(open);
      root.dataset.efQuickAvailable = String(available);
    }
    button.addEventListener('click', () => { open = !open; update(); });
    root.dataset.efQuickReady = 'true';
    update();
    // The chips node is replaced by section rendering; the button and open state survive.
    new MutationObserver(update).observe(bar, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-current','aria-pressed','checked'] });
  }
  function scan(scope = document) {
    scope.querySelectorAll('[data-efxc]').forEach(root => init(root));
    scope.querySelectorAll('[data-bbq-filters]').forEach(root => init(root, true));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), {once:true}); else scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
